module.exports = __webpack_public_path__ + "img/cash_all.3218af1f.svg";